const binding = { modules: {}, dataActions: {} };

    (binding.modules['hei-store-picture'] = {
        c: () => require('partner/modules/hei-store-picture/hei-store-picture.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hei-store-picture',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hei-store-picture'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hei-store-picture|hei-store-picture'] = {
                c: () => require('partner/modules/hei-store-picture/hei-store-picture.view.tsx'),
                cn: '__local__-__local__-hei-store-picture'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };